<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang",
  methods: {
    selectLanguage(code) {
      this.$translate.setLang(code);
    }
  },
  beforeMount() {
    if (this.$route.params.code == "pl") {
      this.$translate.setLang("pl_PL");
    } else if (this.$route.params.code == "en") {
      this.$translate.setLang("en_EN");
    }

    this.$router.push({ name: "Home" });
  }
};
</script>
